import React, {Component} from 'react';
import {Modal, ModalHeader} from 'reactstrap';
import {GiveAccessAdAccountForm} from "./GiveAccessAdAccountForm";

export class GiveAccessAdAccountModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            channel: null,
            adAccountId: null
        };

        this.toggle = this.toggle.bind(this);
        this.afterSuccessfulSubmit = this.afterSuccessfulSubmit.bind(this);
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    setAdAccount(channel, adAccountId) {
        this.setState({
            channel: channel,
            adAccountId: adAccountId
        });
    }

    afterSuccessfulSubmit() {
        this.toggle();
        this.props.afterSuccessfulSubmit(this.props.channel, this.props.adAccountId);
    }

    render() {
        return (
            <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
                <ModalHeader toggle={this.toggle}>Invitar a un usuario a una cuenta publicitaria</ModalHeader>
                <GiveAccessAdAccountForm channel={this.state.channel}
                                         adAccountId={this.state.adAccountId}
                                         afterSuccessfulSubmit={this.afterSuccessfulSubmit}/>
            </Modal>
        );
    }
}
